import { useT } from "../lib/useT";
import { useStore } from "../state/store";

/**
 * One line of truth about the transport.
 *
 * Only states the user can act on, or that explain why the app looks frozen,
 * get a banner; a healthy connection shows nothing at all.
 */
export function ConnectionBanner() {
  const state = useStore((store) => store.connectionState);
  const sendError = useStore((store) => store.sendError);
  const dismissSendError = useStore((store) => store.dismissSendError);
  const t = useT();

  if (sendError) {
    return (
      <div className="banner is-danger">
        <span className="banner-text">{sendError}</span>
        <button type="button" className="banner-action" onClick={dismissSendError}>
          {t("banner.ok")}
        </button>
      </div>
    );
  }

  switch (state.phase) {
    case "pairing":
      return (
        <div className="banner is-warning">
          <span className="spinner" />
          <span className="banner-text">
            {state.message ?? t("banner.pairing")}
          </span>
        </div>
      );
    case "connecting":
      // After a couple of fruitless attempts, say what is actually wrong instead
      // of spinning on "Connecting …" forever.
      return (
        <div className={`banner ${state.message ? "is-warning" : "is-info"}`}>
          <span className="spinner" />
          <span className="banner-text">
            {state.message
              ? `${state.message}${state.remediation ? ` ${state.remediation}` : ""}`
              : t("banner.connecting")}
          </span>
        </div>
      );
    case "reconnecting":
      return (
        <div className="banner is-warning">
          <span className="spinner" />
          <span className="banner-text">{t("banner.reconnecting")}</span>
        </div>
      );
    case "failed":
      return (
        <div className="banner is-danger">
          <span className="banner-text">
            {state.message ?? t("banner.failed")}
            {state.remediation ? ` ${state.remediation}` : ""}
          </span>
        </div>
      );
    default:
      return null;
  }
}
